class ModalController {
    constructor(options = {}) {
      //options
      this.triggerAttr = options.triggerAttr || "data-modal-trigger";
      this.showClass = options.showClass || "active";
  
      // gets all triggers on a page load'
      this.triggers = document.querySelectorAll("[data-modal-trigger]");
      this.modals = Array.from(document.querySelectorAll("[data-modal]"));
  
    
  
      this.addEventListeners();
      this.hasBoxShadow = false;
      this.latestScrollPostion = 0;
      this.tick = false;
      this.header = "modal-header";
    }
  
    addEventListeners() {
  
      //binds event listener to document
      document.addEventListener('click', e => {
        this.handleClick(e);
      });
    }
  
    handleClick(e) {
  
      const el = e.target;
  
      // OPEN //
      //if a trigger element is clicked set the modal to open
      if (el.hasAttribute(this.triggerAttr)) {
        e.preventDefault()
        //  get the id of the corresponding modal from attr value
        const triggerId = el.getAttribute("data-modal-trigger");
        triggerId && this.presentModal(triggerId);
      }
  
      //CLOSE
      // if event has a clsoe attribute close the specific modal
      if (el.hasAttribute("data-modal-close")) {
        e.preventDefault()
        // Get id of modal to close
        const closeId = el.getAttribute("data-modal-close");
        let login = document.querySelector('.customer-login');
        login.setAttribute('data-login', 'guest');
        
        function setCookie(cname, cvalue, exdays) {
          const d = new Date();
          d.setTime(d.getTime() + (exdays*24*60*60*1000));
          let expires = "expires="+ d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        setCookie("customer", "guest", 1)
        
        
        closeId && this.hideModal(closeId);
        location.reload();
      }
    }
  
    presentModal(id, timeOut = 0, product) {
      // find the modal in the dom
      const modal = document.querySelector(`[data-modal="${id}"]`);

      if (modal.getAttribute('data-modal') == 'modal-item-removed' ) {
        
        const prods = document.querySelectorAll('.item');
        const alt_prod_button = document.querySelector('.alternative-products');

        prods.forEach((e)=> {
          let prod = e.getAttribute('data-alt-products');
          let prod_id = e.getAttribute('data-variant-id');
  
          if (prod_id == product){
            if (prod != '') {
                alt_prod_button.href = `collections/${prod}`;
            }
          }
        })
      }
      
      
      // show the modal with active class
      modal.classList.add("active");
  
      // set Timeout to handle animation class adding.
      setTimeout(() => {
        console.log(modal.firstElementChild);
        modal.firstElementChild.classList.add("slide-in-active");
      }, timeOut);
      console.log("present modal" + product)
      return product;
    }
  
    hideModal(id) {
      const modal = document.querySelector(`[data-modal="${id}"]`);

      // OPTIONAL: Remove animation class
      modal.firstElementChild.classList.remove("slide-in-active");
  
      // Hides modal - delayed for animation
      setTimeout(() => {
        if (modal.classList.contains("active")) modal.classList.remove("active");
      }, 200);
  
      this.tick = false;
    }
  
    create(options){
  
      const defaultHTML =`
      <div class="modal slide-in-enter">
        <div class="modal-header">
            <div class="modal-title">Are you sure you want to remove?</div>
            <div class="modal-subtitle">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor?</div>
        </div>
        <div class="modal-body">
            <div data-artwork-file ></div>
            <button class="button-2" data-confirm="true">confirm </button>
            <button class="button-1" data-modal-close="${ options.name }">cancel</button>
        </div>
      </div>
      `
      let config = {
        name: options.name, 
        html: options.html || defaultHTML,
        handler: options.handler
      }
  
      let container = document.createElement('div');
      container.classList.add(config.name)
      container.classList.add('modal-container')
      container.classList.add('basic-confirm')
      container.setAttribute('data-modal-close', config.name)
      container.setAttribute('data-modal', config.name)
      container.innerHTML = config.html;
  
      this.modals.push(container)
      this.modals[this.modals.length -1]._HANDLER = options.handler
      document.body.appendChild(container)
  
      this.modals[this.modals.length -1]._HANDLER();
    }
  }
  
  window.ModalController = ModalController